import EventData from '../event/event-data';
import EventListener from '../event/event-listener';

class MountEvent extends EventData<Mountable> {

}

class MountEventListener extends EventListener<Mountable, MountEvent, any> {
  constructor() {
    super(MountEvent);
  }
}

export default interface Mountable {

  /** @event */
  onMount: MountEventListener;

  /** @event */
  onUnmount: MountEventListener;

  getClassName(): string;

  setClassName(className: string): void;

  persistState(): void;

  restoreState(clear: boolean): void;

  clearPersistedState(): void;

}

export { MountEventListener, MountEvent };
